import styled from "@emotion/styled";
const Styles = styled.div`
  .ant-row {
    display: flex;
  }
  .ant-form-item .ant-form-item-label > label {
    min-width: 171px;
  }

  .service_end_date label {
    height: 36px;
  }
`;

export default Styles;
